import { checkContrast } from '../../utils';
import { ColorValue, HoneycombThemeBase } from '../types';
import { resolveColorValue } from './resolveColorValue';

export function isColorDark(theme: HoneycombThemeBase) {
    return (color: ColorValue): boolean => {
        const colorHexValue = resolveColorValue(theme)(color);
        return checkContrast(colorHexValue, theme.palette.text.inverse);
    };
}
